import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a5f879bb53b0d4edde67a90166a8e87dcb from "./generated-0d57848e-0838-4629-8d32-be8c2aaee0d4.json";

import a3862bc020055049ee0b06e6238e32e16b from "./generated-3446b840-62d3-455d-8b95-d6d93485a8dd.json";

import abe63a21f29b617a616471779e3e9b102b from "./generated-ad78f919-baff-46ea-8319-c84b7ff743d6.json";

import ae79f355499a18dffcfd14f9fda885b38b from "./generated-6c4c8aa6-a47c-40c1-9e4e-4c609ab72089.json";

import ad8cc28b3d3d3f4cafc0d2392251df718b from "./generated-82031477-2679-41ab-b6d8-effd9b645862.json";

import a6c16d78fa0b598286b9cbae143b2ff4ab from "./generated-76a6a4eb-e40c-476d-a582-8d1e99261470.json";

import ad8069654edcc496d4202c619e5ad976ab from "./generated-3bba5498-d771-4160-9ea0-dd8671610211.json";

import a2e3dff11cf18b2c18f4bfaade6df7327b from "./generated-8f7b88da-d356-4300-b495-61abc6604799.json";

import a898a38f4616b0ffa2cc0773804ab78d8b from "./generated-57f8dc2a-782b-4b4f-9594-d355885aee2e.json";

import a49d011f9d5b4809df85412d5c00dbfb1b from "./generated-9e7dcafa-29e3-4202-8346-631b78883031.json";

import a0e2bbaa697cac787475269f5ca11411bb from "./generated-30ea949f-2280-4244-8e40-90897524e307.json";

import a35ca005f03b95de02175e2ebb815411ab from "./generated-6d9fb97f-8226-4b06-b0c8-162f9c38ccbe.json";

import a4847c0af300100b72c25af78fb429c1cb from "./generated-9be9b749-e825-492a-9f39-c5c885c59c8d.json";

import ad4b22f6206d5f44e10b044dd0aa395b5b from "./generated-a82e2837-fd7d-4845-836c-f370b1962fc8.json";

import a82550c9ed703b8eb77a3e29768ecf1e9b from "./generated-9b5ae783-b99e-4a2e-afbb-32b2063ea853.json";

import a5327b08fe27d9d0d809a64aaf82c208bb from "./generated-5d3e32fb-d92c-4b5e-9158-82bea0421f20.json";

import adac2582a6fcba256260c38a929b6e1f1b from "./generated-d0590221-143c-4ece-9a0e-82f68de5f234.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a5f879bb53b0d4edde67a90166a8e87dcb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a3862bc020055049ee0b06e6238e32e16b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(abe63a21f29b617a616471779e3e9b102b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ae79f355499a18dffcfd14f9fda885b38b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ad8cc28b3d3d3f4cafc0d2392251df718b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a6c16d78fa0b598286b9cbae143b2ff4ab);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ad8069654edcc496d4202c619e5ad976ab);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a2e3dff11cf18b2c18f4bfaade6df7327b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a898a38f4616b0ffa2cc0773804ab78d8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a49d011f9d5b4809df85412d5c00dbfb1b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a0e2bbaa697cac787475269f5ca11411bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a35ca005f03b95de02175e2ebb815411ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a898a38f4616b0ffa2cc0773804ab78d8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a4847c0af300100b72c25af78fb429c1cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ad4b22f6206d5f44e10b044dd0aa395b5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a898a38f4616b0ffa2cc0773804ab78d8b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a82550c9ed703b8eb77a3e29768ecf1e9b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a5327b08fe27d9d0d809a64aaf82c208bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(adac2582a6fcba256260c38a929b6e1f1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a82550c9ed703b8eb77a3e29768ecf1e9b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */